import React from 'react';
import Highlighter from 'react-highlight-words';
import { styled } from '@linaria/react';
import { TranslationState } from './ReviewCommentWrapper';
const HighlighterWrapper = /*#__PURE__*/styled('div')({
  name: "HighlighterWrapper",
  class: "h6ck4cv",
  propsAsIs: false
});
interface Props {
  translationState: TranslationState;
  translatedText: string;
  originalText: string;
  searchKeywords?: string[];
}
const ReviewTextComponent: React.FC<Props> = ({
  translationState,
  translatedText,
  originalText,
  searchKeywords
}) => {
  if (translationState === 'translated' && translatedText) {
    return <div dangerouslySetInnerHTML={{
      __html: translatedText
    }} />;
  }
  if (searchKeywords && searchKeywords?.length > 0 && originalText) {
    return <HighlighterWrapper>
        <Highlighter highlightClassName="__reviewTextHighlight" autoEscape textToHighlight={originalText} searchWords={searchKeywords} />
      </HighlighterWrapper>;
  }
  return <>{originalText}</>;
};
export const ReviewText = React.memo(ReviewTextComponent);

require("./ReviewText.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./ReviewText.tsx");